// store.ts
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import userReducer from "./slices/userSlice";
import authReducer from "./slices/authSlice";
import addVehicleReducer from "./slices/addVehicleSlice";
import addRentalReducer from "./slices/rentalSlice";
import addCommunityFeedsReducer from "./slices/communityFeedSlice";
import vehicleFilterReducer from "./slices/vehicleFilterSlice";
import vehicleSearchReducer from "./slices/vehicleSearchSlice";
import dashboardReducer from "./slices/dashboardSlice";
import addCommunitiesReducer from "./slices/communitySlice";

const persistConfig = {
  key: "root",
  storage,
  blacklist: [
    "auth",
    // "addVehicle",
    "addRental",
    "communityFeeds",
    "vehicleFilter",
    "dashboardState",
    "communities",
  ],
};

const rootReducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  addVehicle: addVehicleReducer,
  addRental: addRentalReducer,
  communityFeeds: addCommunityFeedsReducer,
  vehicleFilter: vehicleFilterReducer,
  vehicleSearch: vehicleSearchReducer,
  dashboardState: dashboardReducer,
  communities: addCommunitiesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
